import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@ui/Form";
import { EXCEL_FILE_ACCEPTED_EXTENSIONS } from "@/constants/validation";
import { useMultiStepForm } from "@/hooks";
import DownloadExampleButton from "@/components/DownloadExampleButton";
import { FileUpload } from "@/components/FileUpload";

export const FileSubForm: FC = () => {
  const { t } = useTranslation();
  const { form } = useMultiStepForm();

  return (
    <div className="space-y-4">
      <FormLabel data-test="upload-label" className="text-base">
        {t("step1.file_subform.q1")}
      </FormLabel>
      <div className="flex flex-row flex-wrap items-center gap-4" data-test="summary-upload-note">
        <p className="font-medium">{t("summary.file.exampleNote")}</p>
        <DownloadExampleButton fileUrl="/examples/day-example.xlsx" />
      </div>
      <p className="text-sm font-light" data-test="summary-upload-units-hint">
        {t("summary.file.unitsHint")}
      </p>
      <FormField
        control={form.control}
        name="step1.excelProfile"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <FileUpload
                value={field.value as File | null}
                onChange={field.onChange}
                accept={EXCEL_FILE_ACCEPTED_EXTENSIONS.join(",")}
                isError={Boolean(form.formState.errors.step1?.excelProfile)}
                dataTest="upload"
              />
            </FormControl>
            <FormMessage data-test="upload-error" />
          </FormItem>
        )}
      />
    </div>
  );
};
